import { getPuzzelApi } from '../../puzzelApi'
import { logEvents } from '../logEvents'
import {
  type CopilotPersistentStateV1,
  type HydratedPersistentState,
  STORAGE_KEY,
  deserializeState,
} from './schema'

export const saveSessionState = async (
  state: CopilotPersistentStateV1,
): Promise<void> => {
  try {
    const api = await getPuzzelApi()
    await api.call('widget.saveSession', STORAGE_KEY, state)
    console.info('[sessionPersistence] Session saved successfully', {
      sessionUid: state.session.uid,
      feedLength: state.feed.length,
    })
  } catch (error) {
    console.error('[sessionPersistence] Session save failed', error)
    await logEvents({
      level: 'warn',
      eventType: 'session persistence save failed',
      data: { error },
    })
  }
}

export const loadSessionState =
  async (): Promise<HydratedPersistentState | null> => {
    let raw: unknown = null
    try {
      const api = await getPuzzelApi()
      raw = await api.call('widget.loadSession', STORAGE_KEY)
      const deserialized = deserializeState(raw)
      if (deserialized) {
        console.info('[sessionPersistence] Session loaded successfully', {
          sessionUid: deserialized.session.uid,
          feedLength: deserialized.feed.length,
          savedAt: deserialized.savedAt,
        })
      } else {
        console.warn('[sessionPersistence] No session found in storage')
      }
      return deserialized
    } catch (error) {
      console.error('[sessionPersistence] Session load failed', error, {
        raw,
      })
      await logEvents({
        level: 'warn',
        eventType: 'session persistence load failed',
        data: { error, raw },
      })
      return null
    }
  }

export const clearSessionState = async (): Promise<void> => {
  try {
    const api = await getPuzzelApi()
    await api.call('widget.deleteSession', STORAGE_KEY)
  } catch (error) {
    await logEvents({
      level: 'warn',
      eventType: 'session persistence clear failed',
      data: { error },
    })
  }
}
